import React from "react";
import { CameraIcon, ClipboardCheckIcon, Columns3Icon, MapIcon, TimerIcon } from "lucide-react";
import { Section, SectionHeading } from "./Section";
import { tools } from "../data/volumes";
import { images } from "../data/offer";
const icons = [TimerIcon, ClipboardCheckIcon, MapIcon, Columns3Icon, CameraIcon];
export function ToolsSection() {
  return <Section tone="white" labelledBy="tools-title" cta="I want access to the complete system" data-id="element-317" data-mp="3jk2r4jjuxmo3">
      <SectionHeading id="tools-title" eyebrow="Plus, you'll receive" title="Professional Review Tools" sub="The six volumes provide the framework. These additional tools help you use it consistently." data-id="element-318" data-mp="2vu8heauu4e82" />

      <div className="mt-10 grid items-center gap-8 lg:grid-cols-[1fr_1.1fr] lg:gap-12" data-id="element-319" data-mp="2ztg6m8f0qikq">
        <img src={images.hero} alt="Facelift Blueprint™ professional review tools on tablet, laptop and printed worksheets" className="-mx-4 w-[calc(100%+2rem)] max-w-none sm:mx-0 sm:w-full" data-id="element-320" data-mp="k222e8cfpbbb" />
        <ul className="divide-y divide-line" data-id="element-321" data-mp="2i6btrgkozl7f">
          {tools.map((t, i) => {
          const Icon = icons[i];
          return <li key={t.title} className="flex gap-4 py-5 first:pt-0" data-id="element-322" data-mp="2m6c7eyzyvsdf" data-mpi={i}>
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-navy text-gold-light" data-id="element-323" data-mp="2r6grez03358e">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-324" data-mp="2w4s2fd247ls7" />
                </span>
                <div data-id="element-325" data-mp="1yiueh04yuo8v">
                  <h3 className="text-base font-extrabold uppercase leading-snug tracking-wide text-ink" data-id="element-326" data-mp="1yjdz4om03qql">{t.title}</h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-muted" data-id="element-327" data-mp="23hfhf7blrm10">{t.body}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>

      <p className="mt-8 text-center text-[15px] font-medium text-navy" data-id="element-328" data-mp="2d7qtxi9cr3ji">
        All materials are designed for digital use, printing, and repeated educational review.
      </p>
    </Section>;
}